import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);

const Navbar = () => {

  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Learning & Development");

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-black border-b border-blue-400 shadow-md sticky top-0 z-50">
      <div className="mx-auto px-2 py-3 flex flex-row justify-between">
        <div className="flex items-start gap-2 h-12">
            <div className="flex flex-col justify-start items-start text-left">
                <h1 className="text-lg lg:text-xl font-bold text-yellow-200">
                🍽️ PlateCraft
                </h1>            
                <h2 className="text-xs lg:text-sm font-bold text-white">
                From Kitchen to Table – Perfectly Crafted
                </h2>  
            </div>
        </div>

        <div className="p-2 flex rounded">
          <div className="flex items-center gap-3">
            {isLoggedIn ? (
              <>
                <div className="text-xs lg:text-sm text-teal-300">
                  {userName}
                </div>

                <button
                  onClick={handleLogout}
                  className="p-1 w-6 text-xs lg:text-sm rounded-md
                            bg-red-600 hover:bg-red-700 transition"
                  title="Logout"
                >
                  ⏻
                </button>
              </>
            ) : (
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1 rounded-full border border-gray-700
                          text-xs lg:text-sm text-gray-200 hover:bg-gray-800"
              >
                🔑
              </button>
            )}
          </div>
        </div>

      </div>
    </nav>
  );
};


const TopNav = () => {
  return (
    <section
      id="home"
      className="flex flex-col lg:flex-row lg:justify-between px-4 text-white relative bg-black py-0 gap-1 mt-2 mb-1"
    >
      <div className="w-full">
        <ul className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-8 gap-0.5">

          <li>
            <Link
              to="/orderflow-products/platecraft/innovative"
              className="w-full bg-red-900 hover:bg-red-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">✨</span>
              <span>Innovative</span>
            </Link>
          </li>

          <li>
            <Link
              to="/orderflow-products/platecraft/hero"
              className="w-full bg-red-800 hover:bg-red-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">📊</span>
              <span>Market Trends</span>
            </Link>
          </li>

          <li>
            <Link
              to="/orderflow-products/platecraft"
              className="w-full bg-red-800 hover:bg-red-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🛒</span>
              <span>Marketplace</span>
            </Link>
          </li>

          <li>
                <Link
                    to="/orderflow-products/platecraft/hero"
                    className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                                flex items-center justify-center gap-1
                                text-[10px] text-xs lg:text-sm
                                text-gray-50 hover:text-yellow-200
                                transition text-center leading-tight h-8"
                    >
                    <span className="text-sm lg:text-lg">⭐</span>
                    <span>Hero Products</span>
                </Link>
          </li>

          <li>
                <Link
                    to="/orderflow-products/platecraft/azcor"
                    className="w-full bg-pink-600 hover:bg-pink-700 rounded-lg
                                flex items-center justify-center gap-1
                                text-[10px] text-xs lg:text-sm
                                text-gray-50 hover:text-yellow-200
                                transition text-center leading-tight h-8"
                    >
                    <span className="text-sm lg:text-lg">🅰️</span>
                    <span>AZcor</span>
                </Link>
          </li>          

          <li>
                <Link
                    to="/orderflow-products/platecraft/khurja"
                    className="w-full bg-blue-600 hover:bg-blue-700 rounded-lg
                                flex items-center justify-center gap-1
                                text-[10px] text-xs lg:text-sm
                                text-gray-50 hover:text-yellow-200
                                transition text-center leading-tight h-8"
                    >
                    <span className="text-sm lg:text-lg">🏺</span>
                    <span>Khurja</span>
                </Link>
          </li>   

          <li>
                <Link
                    to="/orderflow-products/platecraft/gifting"
                    className="w-full bg-blue-800 hover:bg-blue-700 rounded-lg
                                flex items-center justify-center gap-1
                                text-[10px] text-xs lg:text-sm
                                text-gray-50 hover:text-yellow-200
                                transition text-center leading-tight h-8"
                    >
                    <span className="text-sm lg:text-lg">🎁</span>
                    <span>Gift A Set</span>
                </Link>
          </li>   

          <li>
            <Link
              to="/crockerytube"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🍽️</span>
              <span>crockeryTube</span>
            </Link>
          </li>      

          <li>
            <Link
              to="/foodtube"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🥘</span>
              <span>foodTube</span>
            </Link>
          </li>                

          <li>
            <Link
              to=""
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🍱</span>
              <span>PlatingMania</span>
            </Link>
          </li>    

          <li>
            <Link
              to=""
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🥗</span>
              <span>RecepieWorld</span>
            </Link>
          </li>  

          <li>
            <Link
              to="/life-chronicles-home"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">📝</span>
              <span>CookingLogs</span>
            </Link>
          </li> 

        <li>
            <Link
              to="/photocanwin"
              className="w-full bg-teal-600 hover:bg-teal-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">📸</span>
              <span>Win Photo Plating</span>
            </Link>
          </li>

          <li>
            <Link
              to="/kharchojeeto"
              className="w-full bg-teal-600 hover:bg-teal-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🪞</span>
              <span>KharchoJeeto</span>
            </Link>
          </li>  

          <li>
            <Link
              to="/orderflow-earning-estimator"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🪙</span>
              <span>DigitalIncome</span>
            </Link>
          </li> 

          <li>
            <Link
              to="/crockery-personalize"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🎨</span>
              <span>Personalize</span>
            </Link>
          </li>

          <li>
            <Link
              to="/bookshelf"
              className="w-full bg-cyan-600 hover:bg-cyan-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">📖</span>
              <span>Monthly Gyan</span>
            </Link>
          </li>              

          <li>
            <Link
              to=""
              className="w-full bg-blue-600 hover:bg-blue-700 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🧑‍💼</span>
              <span>My Account</span>
            </Link>
          </li>            

          <li>
            <Link
              to="/agenticsim"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🤖</span>
              <span>PlateCraft AI</span>
            </Link>
          </li>

          <li>
            <Link
              to="/foodx"
              className="w-full bg-red-700 hover:bg-red-600 rounded-lg
                        flex items-center justify-center gap-1
                        text-[10px] text-xs lg:text-sm
                        text-gray-50 hover:text-yellow-200
                        transition text-center leading-tight h-8"
            >
              <span className="text-sm lg:text-lg">🌐</span>
              <span>Digital Twin</span>
            </Link>
          </li>

        </ul>
      </div>
    </section>
  );
};

const Hero = () => {
  return (
    <section
      id="home"
      className="flex flex-col items-center justify-center h-[40vh] md:h-[40vh] lg:h-[50vh] px-4 ml-4 mr-4 text-white text-center relative
                bg-gradient-to-r from-red-600 via-red-500 to-pink-600"
    >    
      <div className="absolute inset-0 bg-gradient-to-r from-gray-600/70 to-gray-400/70"></div>
      <div className="relative z-10">
        <div className='flex flex-row justify-center items-center'>
          {/* <img src="/assets/banners/crockerylogo.jpg" alt="Crockery AI Logo" className="h-10 w-auto mr-4"/> */}
          <h1 className="text-2xl lg:text-4xl font-bold text-yellow-200">🍽️🥣 🥄 PlateCraft 🍶 🍵🍛</h1>   
        </div>
        <h1 className="text-lg lg:text-2xl font-bold mb-4 text-white">Explore, Personalize & Track Tableware Trends</h1>
        <p className="text-sm lg:text-lg mb-6 text-yellow-300">Discover the best crockery for homes, restaurants, and gifts worldwide.</p>
        <a href="#personalize" className="px-6 py-3 bg-pink-700 text-white rounded-md font-semibold hover:bg-pink-900 hover:text-yellow-200 z-10">
          Start Your Serving
        </a>
      </div>
    </section>
  );
};

// Simple market score for crockery eco & trend preferences
const getScoreMeta = (score) => {
  if (score >= 90) return { label: "Excellent", color: "#16a34a" };
  if (score >= 70) return { label: "Good", color: "#22c55e" };
  if (score >= 50) return { label: "Average", color: "#eab308" };
  return { label: "Needs Attention", color: "#dc2626" };
};

const ScoreChart = ({ score, chartRef }) => {
  const meta = getScoreMeta(score);

  const data = {
    labels: ["Sustainability", "Aesthetics", "Durability", "Remaining"],
    datasets: [
      {
        data: [score * 0.4, score * 0.3, score * 0.2, 100 - score],
        backgroundColor: [meta.color, "#f59e0b", "#3b82f6", "#1f2937"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: { legend: { display: false } },
    cutout: "70%",
  };

  return (
    <div className="relative w-48 h-48 mx-auto">
      <Pie data={data} options={options} />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
        <div className="text-2xl font-bold">{score}%</div>
        <div className="text-xs text-gray-300">{meta.label}</div>
      </div>
    </div>
  );
};

const PersonalizeCrockery = () => {
  const [answers, setAnswers] = useState([]);
  const [score, setScore] = useState(null);
  const chartRef = useRef(null);

  const questions = [
    { emoji: "🍽️", text: "Preferred material?", options: ["Porcelain", "Bone China", "Glass", "Melamine"], type: "single", score: [25, 25, 20, 15] },
    { emoji: "🎨", text: "Favorite style?", options: ["Modern", "Traditional", "Minimalist", "Artisan"], type: "single", score: [20, 25, 15, 20] },
    { emoji: "🌱", text: "Eco preference?", options: ["Yes", "No"], type: "single", score: [20, 5] },
    { emoji: "💰", text: "Budget range?", options: ["₹500–₹2000", "₹2000–₹5000", "₹5000+"], type: "single", score: [15, 20, 25] },
  ];

  const handleSelect = (qIndex, optionIndex) => {
    setAnswers(prev => {
      const updated = [...prev];
      updated[qIndex] = optionIndex;
      return updated;
    });
  };

  const calculateScore = () => {
    let total = 0;
    questions.forEach((q, i) => {
      const ans = answers[i];
      if (ans != null) total += q.score[ans];
    });
    setScore(total);
  };

  return (
    <section id="personalize" className="py-4 px-4 bg-black text-white max-w-3xl mx-auto space-y-4 rounded-2xl border border-gray-700">
      <h2 className="text-lg lg:text-xl text-yellow-200 font-bold mb-2 text-center">
        Personalize Your Crockery Preferences
      </h2>

      {questions.map((q, qIndex) => {
        const selected = answers[qIndex];
        return (
          <div key={qIndex} className="bg-gray-900 p-3 rounded-lg flex flex-col gap-2">
            <h3 className="text-sm lg:text-lg font-semibold text-cyan-300">{q.emoji} {q.text}</h3>
            <div className="flex flex-wrap gap-2">
              {q.options.map((opt, optIndex) => (
                <button
                  key={optIndex}
                  onClick={() => handleSelect(qIndex, optIndex)}
                  className={`px-3 py-1 text-xs lg:text-sm rounded-md border transition font-medium
                    ${selected === optIndex ? "bg-red-600 border-red-500 shadow-sm" : "bg-gray-700 border-gray-600 hover:bg-gray-600"}`}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        );
      })}

      <button
        onClick={calculateScore}
        className="mt-3 w-full bg-red-600 hover:bg-red-700 px-4 py-2 rounded-md font-semibold text-white"
      >
        Submit Preferences
      </button>

      {score !== null && <ScoreChart score={score} chartRef={chartRef} />}
    </section>
  );
};

export default function CrockeryHome() {
  return (
    <div className="bg-black text-white min-h-screen">
      <Navbar />      
      <TopNav />
      <Hero />
      <PersonalizeCrockery />
    </div>
  );
}
